import { render, staticRenderFns } from "./BookContent.vue?vue&type=template&id=0688436c&scoped=true&"
import script from "./BookContent.vue?vue&type=script&lang=js&"
export * from "./BookContent.vue?vue&type=script&lang=js&"
import style0 from "./BookContent.vue?vue&type=style&index=0&id=0688436c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688436c",
  null
  
)

export default component.exports